import { type ResponseVariant, transitionDurations } from "@huub-web/ui";
import type { MotionProps } from "motion/react";

export const responsesMotionProps: Record<ResponseVariant, MotionProps> = {
  sideContent: {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        duration: transitionDurations.m,
        delay: transitionDurations.s,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: transitionDurations.m,
      },
    },
  },
  hub: {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        duration: transitionDurations.m,
        delay: transitionDurations.s,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: transitionDurations.m,
      },
    },
  },
  history: {
    transition: {
      duration: transitionDurations.m,
    },
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
    },
  },
};
